import * as React from "react";
import { Box, Typography } from "@mui/material";

interface PageHeaderProps {
  title: string;
  description?: string | React.ReactNode;
  actions?: React.ReactNode;
  extraContent?: React.ReactNode;
}

export default function PageHeader({ title, description, actions, extraContent }: PageHeaderProps) {
  return (
    <Box sx={{ mb: 2, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
      <Box sx={{ minWidth: { xs: "100%", sm: "auto" } }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: "#1e293b", mb: 0.5, fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" sx={{ color: "#64748b", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
            {description}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap", width: { xs: "100%", sm: "auto" } }}>
        {actions}
      </Box>
      {extraContent && <Box sx={{ width: "100%" }}>{extraContent}</Box>}
    </Box>
  );
}
